import { largeDecimalFormat } from 'common/formats/formats';
import { ParserParams } from 'models/interfaces/spreadsheet-types/core-types';
import commonInvestmentParser from '../../commonInvestmentParser';

export interface FirmInvestmentColumn {
  label: string;
}

const firmInvestmentParser = (params: ParserParams<FirmInvestmentColumn, object, object, object>) =>
  commonInvestmentParser({
    ...params,
    options: {
      useValueDirectly: false,
      shareCountFormat: largeDecimalFormat,
      lastRowFirstColumnFormat: largeDecimalFormat,
      useTotalValueCustomKey: true,
    },
  });

export default firmInvestmentParser;
